import React from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

const ICInput = props => {
  const {
    isSelect = false,
    options = [],
    rows,
    className = "",
    children,
    ...rest
  } = props;

  return (
    <TextField
      select={isSelect}
      InputLabelProps={{ shrink: true }}
      multiline={!isSelect && rows && rows > 1}
      autoComplete="new-password"
      className={`ic-input ${className}`}
      {...rest}
    >
      {isSelect
        ? options.map((option, index) => (
          <MenuItem key={index} value={option}>
            {option}
          </MenuItem>
        ))
        : children}
    </TextField>
  );
};

export default ICInput;
